import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PeopleService } from '../../../../shared/services';
import { InspectionPlugin } from '../../../../shared/models';
import { BasePluginMenuComponent } from '../../../../menus';

@Component({
    templateUrl: 'preview-validation-messages.component.html',
    selector: 'preview-validation-messages',
    standalone: false
})
export class PluginPreviewValidationMessagesComponent {
  @Input() showValidations: boolean;
  @Input() messages: Array<string>;
}
